module.exports = __webpack_public_path__ + "static/media/bn.e1882e0d.svg";